import { useState } from 'react'

import { getAPIClient } from 'api/axios'

import { Coupon, CouponDiscountType } from '../types/coupon'
import { couponErrorMessage } from './couponErrorMessage'

interface CreateCouponParams {
  code: string
  discount_type: CouponDiscountType
  discount_value: number
  max_discount?: number | null
  max_usage?: number | null
  single_use_per_customer?: boolean
  expires_at?: string | null
}

interface UseCreateCouponReturn {
  createCoupon: (params: CreateCouponParams) => Promise<Coupon | null>
  loading: boolean
  error: string | null
}

export const useCreateCoupon = (): UseCreateCouponReturn => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const client = getAPIClient()

  const createCoupon = async (
    params: CreateCouponParams
  ): Promise<Coupon | null> => {
    setLoading(true)
    setError(null)

    try {
      const response = await client.post('/v1/coupons', params)
      return response.data.record ?? response.data.coupon
    } catch (err: any) {
      const message = couponErrorMessage(err, 'Erro ao criar cupom')
      setError(message)
      throw message
    } finally {
      setLoading(false)
    }
  }

  return { createCoupon, loading, error }
}
